import { InfoOutlined } from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { Tooltip } from "../../../components";
import { useLocalization } from "../../../hooks/useLocalization";

interface WhitelistStatusViewProps {
  hasWhitelist: boolean;
}

export const WhitelistStatusView: FC<WhitelistStatusViewProps> = ({
  hasWhitelist,
}) => {
  const { t } = useLocalization();
  const theme = useTheme();

  return (
    <Box display="flex" gap={1} sx={{ alignItems: "center" }}>
      <Typography
        sx={{
          fontSize: 14,
          color: theme.colors.text[5],
          fontWeight: 500,
        }}
      >
        {hasWhitelist
          ? t("licenses.whitelistEnabled")
          : t("licenses.whitelistDisabled")}
      </Typography>
      <Tooltip message={t("licenses.whitelistTooltip")} placement="right">
        <InfoOutlined
          sx={{
            fontSize: 18,
            color: theme.colors.secondary[6],
            cursor: "pointer",
          }}
        />
      </Tooltip>
    </Box>
  );
};
